import moment from "moment";
import { isJsonString } from "../../../../lib/validation";
import { Event } from "./types";
import { TMeetingResponse } from "../../../tanstackQuery/social-integrations/types";
import { ZOOM_MEETING_SOURCE } from "../../../constants";

export const perseEventsWithZoom = (
  calendarEvents: any[],
  calendarEventsByZoomUserUUID: any,
  zoomMeetings: TMeetingResponse[]
): Event[] => {
  return calendarEvents?.map((event) => {
    const _conferenceName = event?.conferenceData?.conferenceSolution?.name;
    const attendees = event?.attendees?.filter(att => !att.hasOwnProperty('organizer'))?.map(att  => att.email);
    const { zoomMeetingDetails } = event
    const isZoomMeeting = zoomMeetingDetails?.meetingSource !==ZOOM_MEETING_SOURCE.NONE && zoomMeetingDetails?.joinUrl !==null
    const meetingId = event?.zoomMeetingDetails?.meetingId;
    const userEvent = calendarEventsByZoomUserUUID.find(
      (userEvent) => userEvent.zoomMeetingID == meetingId
    );
    const zoomMeeting = zoomMeetings?.find(
      (item) => item.zoomMeetingID === Number(meetingId)
    );

    const shouldBeRecorded = userEvent ? userEvent.shouldBeRecorded : false;
    const _meetingParams =
      event?.extendedProperties?.shared?.meetingParams || null;
    const meetingParams = isJsonString(_meetingParams)
      ? JSON.parse(_meetingParams)
      : {};

    const _videoEntryPoint = event?.conferenceData?.entryPoints?.find(
      (el) => el.entryPointType === "video"
    );
    const _phoneEntryPoint = event?.conferenceData?.entryPoints?.find(
      (el) => el.entryPointType === "phone"
    );

    const isMicrosoftMeeting = event?.location?.includes("teams.microsoft.com");

    const start = moment(event.start.dateTime);
    const end = moment(event.end.dateTime);

    return {
      id: event.id,
      day: moment(event.start.dateTime).format("ddd"), // Short weekday (e.g., 'Mon')
      month: moment(event.start.dateTime).format("MMM"), // Short month (e.g., 'Jan')
      date: moment(event.start.dateTime).format("D"), // Day of the month (e.g., '31')
      title: event.summary,
      startTime: event.start.dateTime,
      endTime: event.end.dateTime,
      description: event?.description || null,
      time: `${moment(event.start.dateTime).format("LT")} - ${moment(
        event.end.dateTime
      ).format("LT")}`,
      formattedTime: `${start.format('dddd, MMMM D')} - ${start.format('h:mm')} — ${end.format('h:mma')}`,
      isToday: moment(event.start.dateTime).isSame(moment(), "day")
        ? true
        : false,
      isZoomMeeting,
      eventLink: event?.htmlLink,
      selfHosted: event.organizer.self ? true : false,
      meetingId,
      phone: _phoneEntryPoint?.label || null,
      shouldBeRecorded: isZoomMeeting ? shouldBeRecorded : false,
      meetingPassword: isZoomMeeting ? _videoEntryPoint?.passcode : undefined,
      meetingType: meetingParams?.type,
      appTeamID: userEvent?.appTeamID,
      appInterviewID: userEvent?.appInterviewID,
      recurringEventId: event?.recurringEventId || null,
      meetingStatus: zoomMeeting?.recordingStatus,
      meetingUrl: event?.zoomMeetingDetails?.joinUrl,
      conferenceType:
        _conferenceName ||
        (isMicrosoftMeeting ? "Microsoft Team Meeting" : "External Meeting"),
      attendees,
      zoomMeetingDetails:event?.zoomMeetingDetails
    };
  });
};

export const parseEvents = (calendarEvents: any[]): Event[] => {
  return calendarEvents?.map((event) => ({
    id: event.id,
    day: moment(event.start.dateTime).format("ddd"), // Short weekday (e.g., 'Mon')
    month: moment(event.start.dateTime).format("MMM"), // Short month (e.g., 'Jan')
    date: moment(event.start.dateTime).format("D"), // Day of the month (e.g., '31')
    title: event.summary,
    time: `${moment(event.start.dateTime).format("LT")} - ${moment(
      event.end.dateTime
    ).format("LT")}`,
    isToday: moment(event.start.dateTime).isSame(moment(), "day")
      ? true
      : false,
    isZoomMeeting: event?.zoomMeetingDetails?.meetingSource !==ZOOM_MEETING_SOURCE.NONE && event?.zoomMeetingDetails?.joinUrl !==null,
    meetingId: event?.zoomMeetingDetails?.meetingId,
    selfHosted: event.organizer.self ? true : false
  }));
};
